import axios from 'axios';

const API_KEY = process.env.VUE_TRON_PRO_API_KEY;

const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? '/api'  
  : 'https://apilist.tronscan.org'; 

const getHomeData = async () => {
    return await fetchWithCache('homedata', `${API_BASE_URL}/api/system/homepage-bundle`);
}

const getTronOverview = async () => {
    return await fetchWithCache(`overview`, `${API_BASE_URL}/api/overview/acountswithtrx?days=2`);
}

const getAccountDetails = async (address) => {
    return await fetchWithCache(`account_${address}`, `${API_BASE_URL}/api/account?address=${address}`);
};

const getAssetsSummary = async (address) => {
    return await fetchWithCache(`assets_${address}`, `${API_BASE_URL}/api/account/tokens?address=${address}`);
};

const getTransactions = async (address, page, limit) => {
    return await fetchWithCache(`transactions_${address}_page${page}`, 
        `${API_BASE_URL}/api/transaction?address=${address}&onlyConfirmed=true&count=true&start=${page}&limit=${limit}`);
};

const getTrxTrc10Transactions = async (address) => {
    const cacheKey = `trxtrc10_${address}`;
    const baseUrl = `${API_BASE_URL}/api/transfer?sort=-timestamp&count=true&filterTokenValue=1&address=${address}`;
    const headers = { 'TRON-PRO-API-KEY': API_KEY };

    return await fetchWithCache(cacheKey, baseUrl, 600000, headers, true);
};

const getTrc20Transactions = async (address) => {
    const cacheKey = `trc20_${address}`;
    const baseUrl = `${API_BASE_URL}/api/token_trc20/transfers?filterTokenValue=1&relatedAddress=${address}`;
    const headers = { 'TRON-PRO-API-KEY': API_KEY };

    return await fetchWithCache(cacheKey, baseUrl, 600000, headers, true);
};

const getAllTransactions = async (address) => {
    try {
        const response = await axios.get(`https://u134.com/tronApi.php`, {
            params: {
                address: address,
                page: 0,
                limit: 20
            },
            headers: {
                'TRON-PRO-API-KEY': API_KEY
            }
        });

        const allTransactions = response.data;
        
        //console.log(allTransactions);
        return allTransactions;
    } catch (error) {
        console.error('Error fetching transactions:', error);
        return [];
    }
};

const fetchAllPages = async (baseUrl, pageSize = 50, headers = {}) => {
    let allResults = [];
    let currentPage = 0;
    let keepFetching = true;

    while (keepFetching) {
        const url = `${baseUrl}&limit=${pageSize}&start=${currentPage * pageSize}`;
        const res = await axios.get(url, { headers });
        const data = res.data?.data || [];

        allResults = allResults.concat(data);

        if (data.length < pageSize) {
            keepFetching = false;
        } else {
            currentPage++;
        }
    }

    return allResults;
};

const fetchWithCache = async (cacheKey, url, ttl = 600000, headers = {}, usePagination = false) => {
    const cachedData = localStorage.getItem(cacheKey);
    const cachedTime = localStorage.getItem(`${cacheKey}_time`);

    if (cachedData && cachedTime && (Date.now() - cachedTime < ttl)) {
        //return JSON.parse(cachedData);
    }

    try {
        const data = usePagination 
            ? await fetchAllPages(url, 50, headers)
            : (await axios.get(url, { headers })).data;

        localStorage.setItem(cacheKey, JSON.stringify(data));
        localStorage.setItem(`${cacheKey}_time`, Date.now());
        return data;
    } catch (error) {
        console.error(`Error fetching ${url}:`, error);
        return null;
    }
};


export default {
    getHomeData,
    getTronOverview,
    getAccountDetails,
    getAssetsSummary,
    getTransactions,
    getAllTransactions,
    getTrxTrc10Transactions,
    getTrc20Transactions  
};